// extracted by mini-css-extract-plugin
module.exports = {"root":"FetchError_root__3aoLN","icon":"FetchError_icon__2NnWn","descriprion":"FetchError_descriprion__1ChrK"};